var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportDetailStore = function SvgReportDetailStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "reportDetailStore_svg__a",
    width: "106.8%",
    height: "130.7%",
    x: "-3.4%",
    y: "-12.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.5,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    fillRule: "nonzero",
    filter: "url(#reportDetailStore_svg__a)",
    transform: "translate(-42 -76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.842 81.107a.4.4 0 0 0-.02-.064l-1.079-2.763a2.01 2.01 0 0 0-1.88-1.28h-7.587c-.805 0-1.532.478-1.852 1.216l-1.028 2.37a2.9 2.9 0 0 0-.304.74 2.8 2.8 0 0 0 .056 1.607 2.96 2.96 0 0 0 1.08 1.455v3.84a2.04 2.04 0 0 0 2.037 2.036h7.47a2.04 2.04 0 0 0 2.036-2.036V84.4a2.9 2.9 0 0 0 1.177-1.82c.096-.491.06-1-.106-1.473m-2.03 3.737v3.384c-.001.594-.483 1.076-1.077 1.076h-7.47a1.077 1.077 0 0 1-1.076-1.076v-3.386l.068.015.02.006q.094.02.19.034l.031.005q.096.014.194.02a2.88 2.88 0 0 0 2.251-.855 2.88 2.88 0 0 0 4.113 0q.053.055.11.106l.037.033q.038.034.08.067l.045.037.075.057.05.036.075.051.052.034a1 1 0 0 0 .08.047l.053.03.08.044q.025.014.052.027l.091.042.047.02q.06.027.12.049l.02.008.144.048.04.01.107.03.054.013.095.02.06.01q.045.009.09.014l.065.008.09.01.064.004h.307c.05 0 .101-.006.151-.01h.01q.095-.01.19-.026h.027q.09-.015.179-.038zm1.193-2.445a1.95 1.95 0 0 1-.938 1.314l-.014.007a2 2 0 0 1-.334.15l-.074.023-.044.013a1 1 0 0 1-.126.029l-.033.005a2 2 0 0 1-.137.02h-.053a1.92 1.92 0 0 1-1.786-.923.48.48 0 0 0-.82 0 1.92 1.92 0 0 1-3.292 0 .48.48 0 0 0-.82 0 1.93 1.93 0 0 1-1.773.927c-.045 0-.09-.008-.132-.013h-.025a1.98 1.98 0 0 1-1.538-1.319 1.82 1.82 0 0 1-.035-1.105q-.001-.007.004-.016a1.9 1.9 0 0 1 .201-.462l.029-.056 1.04-2.4c.167-.388.548-.64.97-.64h7.588c.436-.001.828.266.986.673l1.06 2.717c0 .013.008.026.012.039.121.325.15.677.084 1.017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.825 80.487h-5.65a.48.48 0 0 0 0 .96h5.65a.48.48 0 1 0 0-.96"
  }))));
};
export default SvgReportDetailStore;